import { useMemo } from "react";

import { EntityId } from "@reduxjs/toolkit";

import { IconButton, Tooltip } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { usePermalinks } from "hooks/usePermalinks";
import { SiteDeviceSelection } from "./store/state";
import * as proto from "src/features/liveStreaming/protobuf/generated/sitedeviceselections_pb";

export interface OpenInNewWindowButtonProps {
    siteId: EntityId;
    deviceId: EntityId;
}

export function OpenInNewWindowButton(props: OpenInNewWindowButtonProps) {
    const { encodePermalink } = usePermalinks<SiteDeviceSelection[]>(
        {},
        proto.SiteDeviceSelectionlistSchema,
    );

    const targetUrl = useMemo(() => {
        const siteDeviceSelections: SiteDeviceSelection[] = [
            {
                siteId: props.siteId,
                pageNumber: 1,
                deviceSelectionIsDoneByPaging: false,
                selectedDevices: [
                    {
                        deviceId: props.deviceId,
                        properties: { streamQuality: null },
                    },
                ],
                devicesWithBadConnection: [],
            },
        ];

        const encodedResult = encodePermalink(siteDeviceSelections);

        return "/livestreaming/" + encodedResult.base64UrlCompressed;
    }, [props.deviceId, props.siteId]);

    return (
        <Tooltip title="Open in new window">
            <IconButton
                href={targetUrl}
                target="_blank"
            >
                <OpenInNewIcon />
            </IconButton>
        </Tooltip>
    );
}
